import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface User {
  id?: string;
  userId?: string;
  username?: string;
  email: string;
  avatar?: string;
  authority: string[];
  firstName?: string;
  lastName?: string;
  role?: string;
  userType?: string;
}

export interface AuthState {
  token: string | null;
  user: User | null;
  signedIn: boolean;
}

const initialState: AuthState = {
  token: null,
  user: null,
  signedIn: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setSignedIn: (state, action: PayloadAction<boolean>) => {
      state.signedIn = action.payload;
    },
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    onSignInSuccess: (state, action: PayloadAction<{ token: string; user: User }>) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.signedIn = true;
    },
    onSignOutSuccess: (state) => {
      state.token = null;
      state.user = null;
      state.signedIn = false;
    },
  },
});

export const {
  setUser,
  setSignedIn,
  setToken,
  onSignInSuccess,
  onSignOutSuccess,
} = authSlice.actions;

export default authSlice.reducer;